<template>
  <div
    ref="fieldProperties"
    class="fieldProperties"
    :fieldModel="fieldModel"
    :pos="pos"
  >
    <div class="fieldInfoItem">Name: {{ fieldModel.fileName }}</div>
    <div class="fieldInfoItem">CreateTime: {{ fieldModel.createTime }}</div>
    <div class="fieldInfoItem">FieldCount: {{ fieldModel.fieldCount }}</div>
    <div class="fieldInfoItem">TotalArea: {{ fieldModel.totalArea }} ha</div>
    <span class="fieldInfoItem">Field: </span>
    <el-dropdown
      size="mini"
      placement="bottom-start"
      @command="dropdownSelectCommand"
    >
      <span class="el-dropdown-link">
        {{ fieldModel.selectField.name
        }}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="item in fieldModel.fields"
          :key="item.fieldId"
          :command="item.name"
          >{{ item.name }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
    <div class="fieldInfo">
      <div class="fieldInfoItem">name: {{ fieldModel.selectField.name }}</div>
      <div class="fieldInfoItem">type: {{ fieldModel.selectField.type }}</div>
      <div class="fieldInfoItem">area: {{ (fieldModel.selectField.area/10000.0).toFixed(2) }} ha</div>
      <div class="fieldInfoItem">
        createTime: {{ fieldModel.selectField.createTime }}
      </div>
      <div class="fieldInfoItem">
        description: {{ fieldModel.selectField.description }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "fieldProperties",
  // 父组件传值
  props: {
    fieldModel: {
      default: () => {
        return {
          fileName: "Test",
          createTime: "2020-12-12 12:00:00",
          fieldCount: 3,
          totalArea: 1.5,
          selectField: {
            name: "boundary",
            type: "boundary",
            area: 0,
            createTime: "2020-12-12 12:00:00",
            description: "description",
          },
          fields: [{ name: "boundary1" }, { name: "boundary2" }],
        };
      },
    },
    pos: { default: ()=>{return { x: 10 , y: 550 }}},
  },
  data() {
    return {
    };
  },
  mounted(){
    this.$refs.fieldProperties.style.setProperty("--left", (this.pos.x+250) + "px");
    this.$refs.fieldProperties.style.setProperty("--top", (this.pos.y-250) + "px");
  },
  updated() {
    this.$refs.fieldProperties.style.setProperty("--left", (this.pos.x+250) + "px");
    this.$refs.fieldProperties.style.setProperty("--top", (this.pos.y-250) + "px");
  },
  methods: {
    // 下拉框选择触发
    dropdownSelectCommand(command) {
      this.fieldModel.selectField = this.fieldModel.fields.find(p=>p.name==command) ;
      this.$emit("selectField",this.fieldModel.selectField);
    },
  },
};
</script>
<style>
.fieldProperties {
  width: 300px;
  position: absolute;
  left: var(--left);
  top: var(--top);
  z-index: 4;
  background-color: aliceblue;
  border-radius: 10px;
  padding: 15px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.fieldInfo {
  margin: 10px auto;
  padding: 10px;
  z-index: 4;
  background-color: aliceblue;
  border-radius: 10px;
  padding: 15px;
  border: thin dashed grey;
}

.fieldInfoItem {
  font-size: smaller;
  color: #020202;
  margin: 10px auto;
}
</style>


// WEBPACK FOOTER //
// src/components/fieldProperties.vue